// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__G1ca3","bannerContent":"Banner_bannerContent__shVko","link":"Banner_link__1-ufm"};